// External payment URLs (from Magic Forest)
export const EXTERNAL_PAYMENT_URLS = {
  GOFUNDME: 'https://gofund.me/fd905ea69',
  PAYPAL: 'https://www.paypal.com/ncp/payment/3XPCWNCYKGV4A',
};

export const handleExternalPaymentClick = (url) => {
  window.open(url, '_blank');
};
